/**
 *  Header.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// components
import HeaderLinks from "./HeaderLinks.jsx";
import logo from "../../assets/img/logo_menu_pc.png";

// template
import { Navbar } from "react-bootstrap";

// routes
import dashboardRoutes from "../../routes/admin.jsx";

// style 
//import "./style.css";
//import "./style_SOUL.css";
//import "./style_DCM.css";
import "./style_ADG.css";

class Header extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      sidebarExists: false
    };
  }
  
  mobileSidebarToggle = (e) => {
    if (this.state.sidebarExists === false) {
      this.setState({
        sidebarExists: true
      });
    }
    e.preventDefault();
    
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";

    node.onclick = function() {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };

    document.body.appendChild(node);
  }

  render() {
    return (
      <Navbar fluid className="header-byway" fixedTop> 
        <Navbar.Header>
          <div className="logo ">
            <a href="" className="simple-text logo-normal">
              <div className="logo-brand">
                <img src={logo} alt="logo_image" className="logoimg" />
              </div>
            </a>
          </div>
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
        </Navbar.Header>
        <Navbar.Collapse>
          <HeaderLinks />
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx